import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Link } from 'components/ui';
import OrderUtils from 'utils/Order';

function EditButton({ creditCard, editText, showEditButtonFirst, editCallback }) {
    if (OrderUtils.isSephoraTempCardType(creditCard)) {
        return null;
    }

    return (
        <>
            <Link
                aria-controls='creditcard_form'
                aria-label={editText + ' ' + creditCard.paymentDisplayInfo}
                paddingX={2}
                paddingY={1}
                margin={-2}
                color='blue'
                data-at={Sephora.debug.dataAt('edit_button')}
                onClick={editCallback(creditCard)}
            >
                {editText}
            </Link>
            {showEditButtonFirst && (
                <Box
                    borderLeft={1}
                    marginX={3}
                    borderColor='divider'
                    css={{
                        '&:last-child': {
                            display: 'none'
                        }
                    }}
                />
            )}
        </>
    );
}

export default wrapFunctionalComponent(EditButton, 'EditButton');
